"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  props: ['editItem', 'roleList'],
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        username: '',
        pwd: '',
        confirmPwd: '',
        role_id: null,
        mobile: ''
      },
      terminalStateList: [{
        id: 1,
        label: '运营中'
      }, {
        id: 2,
        label: '库存'
      }, {
        id: 3,
        label: '测试中'
      }, {
        id: 4,
        label: '维护中'
      }],
      rules: {
        username: [{
          required: true,
          message: '请选择商户名称',
          trigger: 'change'
        }],
        role_id: [{
          required: true,
          message: '请选择终端状态',
          trigger: 'change'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          if (_this.editItem) {
            // 编辑
            _this.form = {
              id: _this.editItem.id,
              username: _this.editItem.username,
              mobile: _this.editItem.mobile,
              role_id: _this.editItem.role_id
            };
          }
        });
      } else {
        this.reset();
      }
    }
  },
  methods: {
    reset: function reset() {
      this.form = this.$options.data().form;
      this.$refs['form'].resetFields();
    },
    submit: function submit() {
      var _this2 = this;
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          // editUser({
          //     id: this.form.id,
          //     username: this.form.username,
          //     pwd: this.form.pwd ? this.$md5(this.form.pwd) : '',
          //     role_id: this.form.role_id,
          // }).then((res) => {
          _this2.dialogVisible = false;
          //     this.$emit('getList')
          // })
        } else {
          // this.$message({
          //     message: '请检查表单错误',
          //     type: 'error',
          // })
          return false;
        }
      });
    }
  }
};
exports.default = _default;